import { render, staticRenderFns } from "./PackageTables.vue?vue&type=template&id=b1263a30"
import script from "./PackageTables.vue?vue&type=script&lang=js"
export * from "./PackageTables.vue?vue&type=script&lang=js"
import style0 from "./PackageTables.vue?vue&type=style&index=0&id=b1263a30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports